var Backbone = require('backbone'),
    VariableInputModel = require('./variableInputModel');


module.exports = Backbone.Collection.extend({

    model: VariableInputModel,

    /* Now only applicable to Variables, not Tokens */
    allInputsAreValid: function() {

        return this.every( function( m ) {
            return m.get('isValid');
        });
    }


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/textStamp/variableInputs/dynamicInputCollection.js
 ** module id = 339
 ** module chunks = 0
 **/